import { SMSearchListItem } from '../../../integrated-client/models'

export interface IRuleSearchesResultsData {
  ruleSearchesList: Array<SMSearchListItem>
  showMore: boolean
}
export class RuleSearchesResultsData implements IRuleSearchesResultsData {

  ruleSearchesList: Array<SMSearchListItem>
  showMore: boolean

  constructor() {
    this.ruleSearchesList = [];
    this.showMore = false;
  }

}